import React from 'react';
import { motion } from 'framer-motion';
import { Check, Minus, Phone } from 'lucide-react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
export function Pricing() {
  const tiers = [{
    id: 'pilot',
    label: 'Entry',
    name: 'PILOT',
    price: '$597',
    tagline: 'Start strong. Site + reviews + lead-capture.',
    popular: false,
    headerBg: 'bg-[#7ECFE3]',
    headerText: 'text-white',
    btnBg: 'bg-[#7ECFE3] hover:bg-[#6BBED4] text-white',
    checkColor: 'text-[#3D9CB3]'
  }, {
    id: 'copilot',
    label: 'Starter',
    name: 'CO-PILOT',
    price: '$1,197',
    tagline: 'Get in the game. Reviews, citations, GBP posts.',
    popular: false,
    headerBg: 'bg-[#2E7FBF]',
    headerText: 'text-white',
    btnBg: 'bg-[#2E7FBF] hover:bg-[#266FA8] text-white',
    checkColor: 'text-[#2E7FBF]'
  }, {
    id: 'autopilot',
    label: 'Growth',
    name: 'AUTOPILOT',
    price: '$2,697',
    tagline: 'Never miss a lead. AI chat, follow-up, CRM.',
    popular: true,
    headerBg: 'bg-[#1A4D8C]',
    headerText: 'text-white',
    btnBg: 'bg-[#1A4D8C] hover:bg-[#163E73] text-white',
    checkColor: 'text-[#1A4D8C]'
  }, {
    id: 'command',
    label: 'Full System',
    name: 'COMMAND CENTER',
    price: '$5,197',
    tagline: 'AI team of 20. Everything, running.',
    popular: false,
    headerBg: 'bg-[#D9342B]',
    headerText: 'text-white',
    btnBg: 'bg-[#D9342B] hover:bg-[#BF2D24] text-white',
    checkColor: 'text-[#D9342B]'
  }];
  const featureMatrix = [{
    group: 'Local SEO Marketing',
    features: [{
      name: '# of Focused Keywords',
      values: ['5', '10', '15', '25']
    }, {
      name: '# of Geo-Targeted Keywords',
      values: ['50', '100', '150', '250']
    }, {
      name: 'Backlink Building',
      values: ['Yes', 'Yes', 'Yes', 'Yes']
    }, {
      name: 'Keyword Research',
      values: ['Up to 20', 'Up to 30', 'Up to 50', 'Up to 100']
    }, {
      name: 'Competitor Research',
      values: ['Yes', 'Yes', 'Yes', 'Yes']
    }, {
      name: 'Competitor Monitoring',
      values: ['Yes', 'Yes', 'Yes', 'Yes']
    }, {
      name: 'On-Page Audit',
      values: ['5 pages', '10 pages', '15 pages', '25 pages']
    }, {
      name: 'Citation Cleanup (one-time)',
      values: ['$500', '$400', '$300', '$200']
    }, {
      name: 'Directory Listings',
      values: ['—', 'Yes', 'Yes', 'Yes']
    }, {
      name: 'Weekly GBP Posts',
      values: ['—', 'Yes', 'Yes', 'Yes']
    }, {
      name: 'XML Sitemap Submission',
      values: ['Yes', 'Yes', 'Yes', 'Yes']
    }, {
      name: 'Ranking Reports (monthly)',
      values: ['Up to 100', 'Up to 100', 'Up to 100', 'Up to 100']
    }]
  }, {
    group: 'Platform Access',
    features: [{
      name: 'Mobile-First Website',
      values: ['Yes', 'Yes', 'Yes', 'Yes']
    }, {
      name: 'ThinkTank Chat (client AI hub)',
      values: ['—', '—', 'Yes', 'Yes']
    }, {
      name: 'Dart Task & Project Management',
      values: ['—', '—', 'Yes', 'Yes']
    }, {
      name: '1Dash.Pro CRM Sub-Account',
      values: ['—', 'Yes', 'Yes', 'Yes']
    }, {
      name: 'Dedicated MR Phone Line (24/7 AI)',
      values: ['—', '—', 'Yes', 'Yes']
    }, {
      name: 'Buildin.ai KB & Docs',
      values: ['—', 'Yes', 'Yes', 'Yes']
    }, {
      name: 'Personalized MISTR (white-label)',
      values: ['—', '—', '—', 'Yes']
    }]
  }, {
    group: 'Reviews & Reputation',
    features: [{
      name: 'Review Automation',
      values: ['Yes', 'Yes', 'Yes', 'Yes']
    }, {
      name: 'Reputation Management',
      values: ['—', 'Yes', 'Yes', 'Yes']
    }, {
      name: 'Review Response (human-tone AI)',
      values: ['—', '—', 'Yes', 'Yes']
    }, {
      name: 'Reputation Reports',
      values: ['—', '—', 'Yes', 'Yes']
    }, {
      name: '$50 Coupon Lead Form',
      values: ['Yes', 'Yes', 'Yes', 'Yes']
    }]
  }, {
    group: 'Content & Media',
    features: [{
      name: 'Blog Posts / Month',
      values: ['1', '1', '1', '1']
    }, {
      name: 'Press Releases / Month',
      values: ['—', '1', '1', '1']
    }, {
      name: 'Off-Site Articles / Month',
      values: ['2', '4', '7', '10']
    }, {
      name: 'Video Creation',
      values: ['Every 6 mo', 'Every 6 mo', 'Every 3 mo', 'Every 2 mo']
    }, {
      name: 'Social Content + Posting',
      values: ['—', '—', '—', 'Yes']
    }]
  }, {
    group: 'Communications',
    features: [{
      name: 'Call Tracking Minutes (included)',
      values: ['150', '250', '500', '1,000']
    }, {
      name: 'Call Tracking Numbers',
      values: ['1', '2', '3', '8']
    }, {
      name: 'Branded Email Accounts',
      values: ['—', '10', '15', '20']
    }, {
      name: '1Dash Email + SMS Marketing',
      values: ['—', '—', 'Yes', 'Yes']
    }, {
      name: '24/7 AI Chat (lead capture)',
      values: ['—', '—', 'Yes', 'Yes']
    }, {
      name: 'Form Auto-Follow-Up',
      values: ['—', '—', 'Yes', 'Yes']
    }]
  }, {
    group: 'Ads & Analytics',
    features: [{
      name: 'Facebook + Google Ads Management',
      values: ['—', '—', '—', 'Yes']
    }, {
      name: '1Dash Pipelines & Automations',
      values: ['—', '—', 'Yes', 'Full']
    }, {
      name: 'Analytics Dashboard',
      values: ['—', '—', '—', 'Yes (advanced)']
    }, {
      name: 'TrueConversion Analytics',
      values: ['—', '—', 'Yes', 'Yes']
    }, {
      name: 'Monthly Strategy Call',
      values: ['—', '—', 'Yes', 'Yes']
    }, {
      name: 'Monthly Report + Priority Support',
      values: ['—', '—', 'Yes', 'Yes']
    }]
  }, {
    group: 'Hosting & Ops',
    features: [{
      name: 'Website Hosting (managed)',
      values: ['—', 'Yes', 'Yes', 'Yes']
    }, {
      name: 'Website Backups',
      values: ['Monthly', 'Weekly', 'Weekly', 'Weekly']
    }, {
      name: 'Setup Fee',
      values: ['Waived', 'Waived', 'Waived', 'Waived']
    }]
  }];
  const renderValue = (val: string, checkColor: string) => {
    if (val === 'Yes') return <span className={`font-bold text-sm ${checkColor}`} data-id="element-1904">Yes</span>;
    if (val === '—') return <Minus size={16} className="text-gray-300 mx-auto" data-id="element-1905" />;
    return <span className="text-gray-700 font-medium text-sm" data-id="element-1906">{val}</span>;
  };
  return <main className="min-h-screen bg-dark-bg text-white font-inter" data-id="element-1907">
      <Helmet data-id="element-1908">
        <title data-id="element-1909">Pricing — MindStream.ing | 4 Tiers, From $597/mo</title>
        <meta name="description" content="Pick your tier. Pilot ($597), Co-Pilot ($1,197), Autopilot ($2,697), Command Center ($5,197). All plans include zero setup fee. 30-day guarantee." data-id="element-1910" />
      </Helmet>

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 px-6 bg-hero-gradient overflow-hidden text-center" data-id="element-1911">
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-purple/20 rounded-full blur-[120px] opacity-30 pointer-events-none" data-id="element-1912" />
        <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-teal/20 rounded-full blur-[100px] opacity-20 pointer-events-none" data-id="element-1913" />

        <div className="relative z-10 max-w-4xl mx-auto" data-id="element-1914">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} data-id="element-1915">
            <span className="font-poppins font-semibold text-xs tracking-[0.15em] uppercase text-cyan-400 mb-4 block" data-id="element-1916">
              Pricing
            </span>
            <h1 className="font-poppins font-extrabold text-5xl md:text-6xl lg:text-7xl text-white leading-[1.1] mb-6" data-id="element-1917">
              Pick the plan that fits <br className="hidden md:block" data-id="element-1918" />
              <span className="text-gradient" data-id="element-1919">your business.</span>
            </h1>
            <p className="text-xl text-steel max-w-2xl mx-auto leading-relaxed" data-id="element-1920">
              Upgrade any time. Every plan = MindStream.ing — your business,
              running itself.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Pricing Matrix - LIGHT background */}
      <section className="py-16 lg:py-24 px-4 lg:px-6 bg-white text-gray-900" data-id="element-1921">
        <div className="max-w-[1400px] mx-auto" data-id="element-1922">
          {/* TABLE — Desktop */}
          <div className="hidden lg:block" data-id="element-1923">
            <div className="rounded-xl overflow-hidden shadow-2xl border border-gray-200" data-id="element-1924">
              {/* Header Row: tier columns with bold colors */}
              <div className="grid grid-cols-[minmax(320px,1.4fr)_repeat(4,1fr)]" data-id="element-1925">
                {/* Left intro cell */}
                <div className="p-8 flex flex-col justify-end bg-white" data-id="element-1926">
                  <p className="font-poppins text-gray-600 italic text-lg leading-snug mb-1" data-id="element-1927">
                    Choose a plan that's right
                  </p>
                  <p className="font-poppins text-gray-600 italic text-lg leading-snug mb-4" data-id="element-1928">
                    for your business.
                  </p>
                  <p className="text-xs text-[#D9342B] font-semibold" data-id="element-1929">
                    ★ Setup fee waived on all plans.
                  </p>
                </div>

                {tiers.map(tier => <div key={tier.id} className={`${tier.headerBg} ${tier.headerText} p-6 text-center relative`} data-id="element-1930">
                    {tier.popular && <div className="absolute top-2 left-1/2 -translate-x-1/2 bg-white/25 backdrop-blur-sm px-3 py-0.5 rounded-full text-[10px] font-bold tracking-wider uppercase" data-id="element-1931">
                        Most Popular
                      </div>}
                    <div className={`text-[11px] font-bold tracking-widest uppercase opacity-90 mb-1 ${tier.popular ? 'mt-4' : ''}`} data-id="element-1932">
                      {tier.label}
                    </div>
                    <div className="font-poppins font-extrabold text-lg tracking-tight mb-4" data-id="element-1933">
                      {tier.name}
                    </div>
                    <div className="font-poppins font-extrabold text-4xl xl:text-5xl leading-none mb-1" data-id="element-1934">
                      {tier.price}
                    </div>
                    <div className="text-xs opacity-95 font-medium" data-id="element-1935">
                      per month
                    </div>
                  </div>)}
              </div>

              {/* Tagline Row */}
              <div className="grid grid-cols-[minmax(320px,1.4fr)_repeat(4,1fr)] bg-gray-50 border-b border-gray-200" data-id="element-1936">
                <div className="p-4" data-id="element-1937"></div>
                {tiers.map(tier => <div key={tier.id} className="p-4 text-center border-l border-gray-200" data-id="element-1938">
                    <p className="text-xs text-gray-600 leading-snug" data-id="element-1939">
                      {tier.tagline}
                    </p>
                  </div>)}
              </div>

              {/* Feature Groups */}
              {featureMatrix.map((group, gIdx) => <div key={gIdx} data-id="element-1940">
                  {/* Group header */}
                  <div className="grid grid-cols-[minmax(320px,1.4fr)_repeat(4,1fr)] bg-[#4A5568]" data-id="element-1941">
                    <div className="px-6 py-3 col-span-5" data-id="element-1942">
                      <h3 className="font-poppins font-bold text-white text-base" data-id="element-1943">
                        {group.group}
                      </h3>
                    </div>
                  </div>

                  {/* Feature rows */}
                  {group.features.map((feature, fIdx) => <div key={fIdx} className={`grid grid-cols-[minmax(320px,1.4fr)_repeat(4,1fr)] ${fIdx % 2 === 0 ? 'bg-white' : 'bg-gray-50'} border-b border-gray-100`} data-id="element-1944">
                      <div className="px-6 py-3 text-sm text-gray-700 font-medium" data-id="element-1945">
                        {feature.name}
                      </div>
                      {feature.values.map((val, vIdx) => <div key={vIdx} className="px-4 py-3 flex items-center justify-center border-l border-gray-100 text-center" data-id="element-1946">
                          {renderValue(val, tiers[vIdx].checkColor)}
                        </div>)}
                    </div>)}
                </div>)}

              {/* CTA Row */}
              <div className="grid grid-cols-[minmax(320px,1.4fr)_repeat(4,1fr)] bg-gray-100 border-t-2 border-gray-200" data-id="element-1947">
                <div className="p-6" data-id="element-1948"></div>
                {tiers.map(tier => <div key={tier.id} className="p-4 border-l border-gray-200 flex items-center justify-center" data-id="element-1949">
                    <button className={`w-full py-3 rounded-md font-poppins font-bold text-sm transition-all ${tier.btnBg} shadow-md`} data-id="element-1950">
                      Get Started
                    </button>
                  </div>)}
              </div>
            </div>
          </div>

          {/* MOBILE — Stacked Cards */}
          <div className="lg:hidden space-y-6" data-id="element-1951">
            {tiers.map(tier => <div key={tier.id} className={`rounded-xl overflow-hidden border ${tier.popular ? 'border-[#1A4D8C] ring-2 ring-[#1A4D8C]/30 shadow-xl' : 'border-gray-200 shadow-md'} bg-white`} data-id="element-1952">
                {/* Mobile Header */}
                <div className={`${tier.headerBg} ${tier.headerText} p-6 text-center relative`} data-id="element-1953">
                  {tier.popular && <div className="absolute top-2 right-2 bg-white/25 backdrop-blur-sm px-3 py-1 rounded-full text-[10px] font-bold tracking-wider uppercase" data-id="element-1954">
                      Most Popular
                    </div>}
                  <div className="text-[11px] font-bold tracking-widest uppercase opacity-90 mb-1" data-id="element-1955">
                    {tier.label}
                  </div>
                  <div className="font-poppins font-extrabold text-2xl mb-3" data-id="element-1956">
                    {tier.name}
                  </div>
                  <div className="font-poppins font-extrabold text-5xl mb-1" data-id="element-1957">
                    {tier.price}
                  </div>
                  <div className="text-sm opacity-95" data-id="element-1958">per month</div>
                  <p className="text-sm opacity-95 mt-4 leading-relaxed" data-id="element-1959">
                    {tier.tagline}
                  </p>
                </div>

                {/* Mobile Features */}
                <div data-id="element-1960">
                  {featureMatrix.map((group, gIdx) => <div key={gIdx} data-id="element-1961">
                      <div className="px-5 py-3 bg-[#4A5568]" data-id="element-1962">
                        <h4 className="font-poppins font-bold text-sm text-white" data-id="element-1963">
                          {group.group}
                        </h4>
                      </div>
                      {group.features.map((feature, fIdx) => {
                  const colIdx = tiers.findIndex(t => t.id === tier.id);
                  const val = feature.values[colIdx];
                  return <div key={fIdx} className={`px-5 py-3 flex items-center justify-between gap-4 ${fIdx % 2 === 0 ? 'bg-white' : 'bg-gray-50'} border-b border-gray-100`} data-id="element-1964">
                            <span className="text-sm text-gray-700 font-medium" data-id="element-1965">
                              {feature.name}
                            </span>
                            <div className="shrink-0" data-id="element-1966">
                              {renderValue(val, tier.checkColor)}
                            </div>
                          </div>;
                })}
                    </div>)}

                  <div className="p-5 bg-gray-100" data-id="element-1967">
                    <button className={`w-full py-4 rounded-md font-poppins font-bold transition-all ${tier.btnBg} shadow-md`} data-id="element-1968">
                      Get Started with {tier.name}
                    </button>
                  </div>
                </div>
              </div>)}
          </div>

          {/* Below Grid Footer */}
          <div className="text-center mt-16 max-w-2xl mx-auto" data-id="element-1969">
            <p className="text-gray-600 mb-6" data-id="element-1970">
              Setup fee waived on all plans. No long-term contract. Cancel
              anytime.
            </p>
            <Link to="/contact" className="inline-flex items-center gap-2 text-[#1A4D8C] font-semibold hover:text-[#163E73] transition-colors text-lg" data-id="element-1971">
              Not sure which? Book a 15-min strategy call →
            </Link>
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="relative py-32 px-6 bg-hero-gradient overflow-hidden flex items-center justify-center text-center border-t border-white/10" data-id="element-1972">
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-purple/20 rounded-full blur-[120px] opacity-30 pointer-events-none" data-id="element-1973" />
        <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-teal/20 rounded-full blur-[100px] opacity-20 pointer-events-none" data-id="element-1974" />

        <div className="relative z-10 max-w-3xl mx-auto" data-id="element-1975">
          <h2 className="font-poppins font-extrabold text-4xl md:text-5xl text-white mb-6" data-id="element-1976">
            Still have questions?
          </h2>
          <p className="text-xl text-steel mb-10" data-id="element-1977">
            Talk to MR (our AI) right now
          </p>
          <a href="tel:760-334-6463" className="inline-flex items-center gap-3 bg-cyan-400 text-[#0F1D3A] px-8 py-4 rounded-xl font-poppins font-bold text-xl md:text-2xl hover:bg-cyan-300 transition-colors shadow-[0_0_40px_rgba(6,182,212,0.3)] mb-8" data-id="element-1978">
            <Phone size={28} data-id="element-1979" />
            760-334-MIND
          </a>
          <p className="text-steel text-sm" data-id="element-1980">
            All plans include zero setup fee. 30-day satisfaction guarantee.
          </p>
        </div>
      </section>
    </main>;
}